// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { FormikContextType } from 'formik'
import { FC } from 'react'
import styled from 'styled-components'

import { Info, TypeStyle } from '@syconium/little-miss-figgy'

import { EmbroideryTypeEnum } from '../../../../../__generated__/graphql/catalog/graphql'
import { useLocalization } from '../../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { useFixturesContext } from '../../../../../brunswick/containers/fixtures'
import { EmbroideryService } from '../../../../../containers/EmbroideryService'
import { DTCLogoSetupFormValues } from '../../../../../containers/EmbroideryService/types'
import { trackEvent } from '../../../../../lib/analytics'
import { intlPrettyCurrency } from '../../../../../lib/utils'
import { RequiredAsterisk } from '../../../../atoms/RequiredAsterisk'
import { ErrorMessage, Label, PriceLabel, StyledTooltip } from '../../shared-form-styles'

import { EmbroideryRadio } from './EmbroideryRadio'

interface Props {
  form: Pick<FormikContextType<DTCLogoSetupFormValues>, 'getFieldProps' | 'touched' | 'errors'>
}

export const LogoColorSelector: FC<Props> = ({ form }) => {
  const { embroideryVariantsByKind } = EmbroideryService.useContainer()
  const { region, locale } = useLocalization()
  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: fixtures },
      },
    },
  } = useTranslation()
  const { logoColorSelectionTooltip } = useFixturesContext()
  const name = 'digitization_setting'
  const logoColorKinds = [
    'LOGO_BLACK_WHITE',
    'LOGO_COLOR',
  ] as const satisfies Array<EmbroideryTypeEnum>

  return (
    <div role='group'>
      <RadioLabel>
        <span>
          <LogoColorLabel>{fixtures.logoColorLabel}</LogoColorLabel>
          <RequiredAsterisk />
        </span>
        <StyledTooltip content={<>{logoColorSelectionTooltip}</>}>
          <button type='button' aria-label={fixtures.ariaLabelLogoColorTooltip}>
            <Info height='12px' width='12px' fill='#282828' />
          </button>
        </StyledTooltip>
        {form.getFieldProps(name).value && (
          <SelectedColorLabel>
            {form.getFieldProps(name).value === 'BLACK_WHITE'
              ? fixtures.logoStrings.LOGO_BLACK_WHITE?.title
              : fixtures.logoStrings.LOGO_COLOR?.title}
          </SelectedColorLabel>
        )}
      </RadioLabel>
      {embroideryVariantsByKind &&
        logoColorKinds.map(kind => {
          const variant = embroideryVariantsByKind[kind]
          const price = intlPrettyCurrency({
            unit: 'cents',
            value: variant?.price,
            region: region,
            locale: locale,
            truncateTrailingZeros: true,
          })
          const fixedHeapValue = kind === 'LOGO_BLACK_WHITE' ? 'Black and White' : 'Full Color'
          const digitizationSettingValue = kind === 'LOGO_BLACK_WHITE' ? 'BLACK_WHITE' : 'COLOR'
          return (
            <EmbroideryRadio.Label key={kind}>
              <EmbroideryRadio.Button
                {...form.getFieldProps({
                  name: name,
                  value: digitizationSettingValue,
                  type: 'radio',
                })}
                {...trackEvent({
                  category: 'embroidery',
                  action: 'select logo color',
                  value: fixedHeapValue,
                })}
                aria-label={fixtures.logoStrings[kind]?.title}
              >
                {fixtures.logoStrings[kind]?.title}
              </EmbroideryRadio.Button>
              <PriceLabel>{price}</PriceLabel>
            </EmbroideryRadio.Label>
          )
        })}
      {form.errors[name] && (
        <ErrorMessage inset role='alert'>
          {form.errors[name]}
        </ErrorMessage>
      )}
    </div>
  )
}

const RadioLabel = styled(Label)`
  display: flex;
  gap: ${o => o.theme.spacing(2)};
  margin-bottom: 0;
  align-items: center;
`

const LogoColorLabel = styled(TypeStyle.HeadlineMicro)`
  display: inline;
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.wide};
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: ${o => o.theme.typography.font.lineHeight.loose};
`

const SelectedColorLabel = styled(TypeStyle.HeadlineMicro)`
  text-transform: capitalize;
  font-weight: ${o => o.theme.typography.font.weight[400]};
  color: ${o => o.theme.color.deprecated.obsidianLight};
  line-height: 18px;
`
